import { FC } from "react";

import { Dialog } from "@bps/fluent-ui";

import { advancedSearchDialogInnerWrapperStyles } from "./AdvancedSearchDialogInner.styles.ts";
import { AdvancedSearchDialogInner } from "./AdvancedSearchDialogInner.tsx";

interface AdvancedSearchDialogProps {
  showAdvancedSearchDialog: boolean;
  onDismiss: () => void;
  onPassSelectionChange: (value: string | undefined) => void;
}

export const AdvancedSearchDialog: FC<AdvancedSearchDialogProps> = ({
  showAdvancedSearchDialog,
  onDismiss,
  onPassSelectionChange
}) => {
  return (
    <Dialog
      hidden={!showAdvancedSearchDialog}
      onDismiss={onDismiss}
      maxWidth={1200}
      minWidth={1200}
      dialogContentProps={{
        title: "Advanced search",
        showCloseButton: true
      }}
      modalProps={{
        styles: {
          main: { height: 640 },
          scrollableContent: {
            "> div": {
              ...advancedSearchDialogInnerWrapperStyles,
              height: "100%"
            }
          }
        }
      }}
      styles={{
        root: {
          ".ms-Dialog-inner": advancedSearchDialogInnerWrapperStyles,
          ".ms-Dialog-content": advancedSearchDialogInnerWrapperStyles
        }
      }}
    >
      <AdvancedSearchDialogInner
        onDismiss={onDismiss}
        onPassSelectionChange={onPassSelectionChange}
      />
    </Dialog>
  );
};
